import { Business } from "@mui/icons-material";
import TestReducer from "./reducer/BusinessReducer";
import JobReducer from "./reducer/JobReducer";
import ReportReducer from "./reducer/ReportReducer";
import UserReducer from "./reducer/UserReducer";
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk'
import BusinessReducer from "./reducer/BusinessReducer";


const reducers=combineReducers({
    User:UserReducer,
    Business:BusinessReducer,
    Job:JobReducer,
    Report:ReportReducer

})

const store=createStore(reducers,applyMiddleware(thunk))
export default store;